import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";
import { ReportHeaderBase } from "altus-ui-components";

import {
  getGroupFromState,
  getLocationGroupsFromState,
} from "features/planner/planner.selectors";

import { toHeliReport } from "utils/route.util";
import LoadingButton from "app/components/LoadingButton";
import FilterDropdownMenu from "app/components/FilterDropdownMenu";
import { heliReportOnSubmit } from "features/planner/report/report.actions";
import { HELI_REPORT_FORM } from "features/planner/report/report.constants";

class HeliReportHeader extends PureComponent {
  render() {
    const {
      group,
      match,
      submitting,
      handleSubmit,
      locationGroups,
    } = this.props;

    const { groupId } = match.params;

    return (
      <ReportHeaderBase>
        <Grid xs item container spacing={2} wrap="nowrap" alignItems="center">
          <Grid item />
          <Grid item xs>
            <FilterDropdownMenu
              label="Location"
              value={group ? group.get("name") : "Select a Location"}
            >
              {locationGroups.map(locationGroup => (
                <MenuItem
                  component={Link}
                  key={locationGroup.get("id")}
                  value={locationGroup.get("id")}
                  to={toHeliReport(locationGroup.get("id"))}
                >
                  {locationGroup.get("name")}
                </MenuItem>
              ))}
            </FilterDropdownMenu>
          </Grid>
          <Grid item>
            <LoadingButton
              size="medium"
              type="submit"
              variant="contained"
              loading={submitting}
              disabled={submitting || !groupId}
              onClick={handleSubmit}
            >
              Download
            </LoadingButton>
          </Grid>
        </Grid>
      </ReportHeaderBase>
    );
  }
}

export default compose(
  connect(
    (state, { match }) => {
      const { groupId } = match.params;

      return {
        locationGroups: getLocationGroupsFromState(state),
        group: groupId ? getGroupFromState(state, groupId) : undefined,
      };
    },
    {
      onSubmit: heliReportOnSubmit,
    },
  ),
  reduxForm({
    form: HELI_REPORT_FORM.ID,
  }),
)(HeliReportHeader);
